import { NavigateFunction } from "react-router-dom";
import { IUser } from "../interfaces/IUser";
import { IDataContext } from "../interfaces/IDataContext";
import { ICustomer } from "../interfaces/ICustomer";
import { handleMessage } from "./stateHelper";
import { t } from "i18next";

export const onUserVerification = (
  isVerified: boolean,
  dataContext: IDataContext,
  setUser: React.Dispatch<React.SetStateAction<IUser>>,
  navigate: NavigateFunction,
  response?: any
) => {
  if (isVerified) {
    const firstLogin = response?.user?.firstLogin;

    const verifiedUser: IUser = {
      id: response.user.id,
      token: response.token,
      title: response.user.title,
      username: response.user.username,
      firstLogin: firstLogin,
    };

    const customers: ICustomer[] = response.customers ?? [];
    const storedCustomerId = localStorage.getItem(`selectedCustomer_${verifiedUser.id}`);
    const selectedCustomer: ICustomer | undefined =
      (storedCustomerId ? customers.find((c) => String(c.id) === storedCustomerId) : undefined) ?? customers[0];

    !firstLogin &&
      localStorage.setItem("authenticatedUser", JSON.stringify(verifiedUser));

    setUser(verifiedUser);

    dataContext.setRootState((prev) => ({
      ...prev,
      authUser: verifiedUser,
      customers,
      selectedCustomer,
    }));

    navigate(firstLogin ? "/set-password" : "/");

    handleMessage(
      dataContext.setRootState,
      firstLogin ? "info" : "success",
      firstLogin
        ? t("info.firstLogin")
        : `${t("success.login")} ${response?.user?.title}!`
    );
  } else {
    const userId = dataContext.state.authUser?.id;
    if (userId) localStorage.removeItem(`selectedCustomer_${userId}`);
    localStorage.removeItem("authenticatedUser");
    setUser(undefined);
    dataContext.setRootState((prev) => ({
      ...prev,
      authUser: undefined,
      customers: [],
      selectedCustomer: undefined,
    }));
    navigate("/login");
  }
};
